import React from 'react';
import { Tag } from '../../../Tag/Tag';
const clickEvent = evt => evt.stopPropagation();
export const GenericSelectControlMultiValue = ({
  id,
  removeProps,
  children,
  className,
  selectProps: {
    isDisabled
  }
}) => React.createElement(Tag, {
  id: id,
  label: children,
  className: className,
  disabled: isDisabled,
  renderIcon: icon => React.createElement("div", removeProps, icon),
  onClick: clickEvent
});
GenericSelectControlMultiValue.__docgenInfo = {
  componentName: "GenericSelectControlMultiValue",
  packageName: "@jutro/components",
  description: "",
  displayName: "GenericSelectControlMultiValue",
  methods: [],
  actualName: "GenericSelectControlMultiValue"
};